
import {Injectable} from '@angular/core';
import {ApiService} from "../../api.service";

@Injectable({
  providedIn: 'root'
})
export class ApiAdminEmailTemplatesService {

  apiUri = '/api/admin/emailtemplates'

  constructor(private apiService: ApiService) {
  }

  listAll(typeId) {
    return this.apiService.get(`${this.apiUri}/type/${typeId}`);
  }

  override(typeId, name) {
    return this.apiService.put(`${this.apiUri}/type/${typeId}/override/${name}`);
  }

  get(id) {
    return this.apiService.get(`${this.apiUri}/${id}`);
  }

  delete(id) {
    return this.apiService.delete(`${this.apiUri}/${id}`);
  }

  create(data) {
    return this.apiService.post(this.apiUri, data);
  }

  update(id, data) {
    return this.apiService.put(`${this.apiUri}/${id}`, data);
  }


}



